<span
    class="fcp-button-content"
    [ngClass]="{
        'fcp-button-content--icon-only-s': iconOnly && size === 'small',
        'fcp-button-content--icon-only-m': iconOnly && size === 'medium',
        'fcp-button-content--icon-only-l': iconOnly && size === 'large'
    }"
    ><ng-content></ng-content>
</span>
